namespace('compass.hotel');

compass.require('compass.hotel.BookingGridHelperWidget');
compass.requireLib('compass.util.format');

compass.hotel.GroupHousingListWidget = compass.defineWidget(function GroupHousingListWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _WUID = _settings.WUID;
	var _cf = _settings.meetingInfo.defaultCurrencyFormatter;

	var _setupControls = this.setupControls = function() {
	};

	var _render = this.render = function(widgetElem) {
		var d = _d;
		for (var i=0; i<_settings.groupAvailableHousing.length; i++){
			me.drawHotelBox(_settings.groupAvailableHousing[i], widgetElem);
		}
		_setupControls();
	};
	
	this.drawHotelBox = function (housingArr,  container){
		var d = _d;
		var hotelDistance = _settings.hideDistance ? "" : Number(housingArr.HOTELINFO.DISTANCE).toFixed(1) + ' ' + housingArr.HOTELINFO.UNITS + ' to Event Location';
		var hotelBoxDiv = d.div({className:"groupHotelBox"});
		var hotelImgCntnr = d.div({className:"hotelImgCntnr"},
								d.img({
									className:"hotelImg",
									src : housingArr.HOTELINFO.PRIMARY_IMAGE
								})
							);
		var hotelContentCntnr = d.div({className:"hotelContentCntnr"}); 
		var hotelHeaderDiv = d.div({className:"groupHotelBoxHeader"}, 
								d.div({className:"groupHotelName"}, housingArr.HOTELINFO.NAME),
								d.div({className:"groupHotelDistance"}, hotelDistance)
						);
		hotelBoxDiv.append(hotelImgCntnr); 
		hotelContentCntnr.append(hotelHeaderDiv);

		if (_.indexOf(_settings.groupAvailableHousing, housingArr) === 0) {
			_bookingGridHelperWidget = new compass.hotel.BookingGridHelperWidget(hotelContentCntnr, {
				message : "Not seeing the dates you need? Select the closest option and make edits later.",
				groupMax: 1
			});
		}

		hotelBoxDiv.append(hotelContentCntnr); 
		hotelBoxDiv.append(d.div({className: "clear"})); 

		for(var j=0; j<housingArr.ROOMTYPESARRAY.length; j++){
			roomTable = me.drawRoomTable(housingArr.ROOMTYPESARRAY[j]);
			hotelContentCntnr.append(roomTable);
		}

		container.append(hotelBoxDiv);
	};
	
	this.drawRoomTable = function(roomArr){
		var d = _d;
		roomTableDiv = d.div({className:"roomTableDiv"},
			d.div({className:"folderTab"},
			d.div({className:"roomNameHeaderDiv"}, roomArr.ROOM_TYPE_NAME)),
			d.div({ className : 'folderHeaderWrapper' },
				d.div({className:"checkInHeaderDiv folderHeader"}, "Check-in"),
				d.div({className:"checkOutHeaderDiv folderHeader"}, "Check-out"),
				d.div({className:"rateHeaderDiv folderHeader"}, "Avg. Nightly Rate"),
				d.div({className:""})
			)
		);
		for(var k=0; k<roomArr.STAYARRAY.length; k++){
			roomRowDiv = me.drawRoomRow(roomArr.STAYARRAY[k], roomArr.BLOCKED_ROOM_ID);
			roomTableDiv.append(roomRowDiv);
		}
		return roomTableDiv;
	};
	
	this.drawRoomRow = function(stayArr, brID){
		var d = _d;
		roomRate = _cf(stayArr.AVERAGENIGHTLYRATE);
		roomRowDiv = d.div({className:"roomRowDiv"},
			d.div({className:'roomCheckIn column'}, stayArr.ARRIVE),
			d.div({className:'roomCheckOut column'}, stayArr.DEPART),
			d.div({className:'roomRate column'}, roomRate),
			d.div({className:'roomSelectButton column'}, 
				d.div({className: 'selectGroupRoomButton'},
						d.div({className:"fa-duotone fa-circle-chevron-right"})
				)
			)
		).activate(
			function(evt) {
				me.housingClickedEvent(brID,stayArr.UNFORMATTEDARRIVE,stayArr.UNFORMATTEDDEPART);
			}
		);
		return roomRowDiv;
	};
	
	this.housingClickedEvent = function(blockedRoomId,arrive,depart) {
		me.trigger('housingRowClicked', {'blockedRoomId' : blockedRoomId, 'arrive' : arrive, 'depart' : depart});
	};
	
	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'defaultGroupHousingListWidgetWUID',
	widgetName : 'GroupHousingListWidget',
	subclass : false,
	groupAvailableHousing : [],
	meetingInfo : { }
});
